function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#4e4e4e",
  d: "M5.313 6C4.14 6 3.188 5.103 3.188 4s.952-2 2.125-2c1.172 0 2.125.897 2.125 2s-.953 2-2.125 2zM4.25 4c0 .551.477 1 1.063 1 .585 0 1.062-.449 1.062-1 0-.551-.477-1-1.062-1-.586 0-1.063.449-1.063 1zM17 .5v11c0 .276-.238.5-.531.5H.53C.238 12 0 11.776 0 11.5V.5C0 .224.238 0 .531 0h15.938c.293 0 .531.224.531.5zM1.063 1v10H4.03l6.22-5.853a.555.555 0 0 1 .75 0l4.938 4.646V1zm9.562 5.207L5.533 11h10.185z"
})));

var SvgIconImage = function SvgIconImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-image.b4d1a922.svg";
export { ForwardRef as ReactComponent };